import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Chat from '../views/Chat.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import UserList from '../views/UserList.vue'
import HistoryRecord from '../views/HistoryRecord.vue'
import StandardEditorPage from '../views/StandardEditorPage.vue'
import { isSuperAdmin, isAdmin } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: Home,
    meta: { requiresAuth: false }
  },
  {
    path: '/chat',
    name: 'ChatPage',
    component: Chat,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: Login
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: Register
  },
  {
    path: '/users',
    name: 'UserList',
    component: UserList,
    meta: { 
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/history',
    name: 'HistoryRecord',
    component: HistoryRecord,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/standard-editor/:fileId',
    name: 'StandardEditorPage',
    component: StandardEditorPage,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 导航守卫，检查用户是否已登录
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresSuperAdmin = to.matched.some(record => record.meta.requiresSuperAdmin);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const token = localStorage.getItem('token');
  
  if (requiresAuth && !token) {
    next('/login');
  } else if (requiresSuperAdmin && !isSuperAdmin()) {
    // 如果需要超级管理员权限，但用户不是超级管理员，则跳转到首页
    next('/');
  } else if (requiresAdmin && !isAdmin()) {
    // 如果需要管理员权限，但用户不是管理员，则跳转到首页
    next('/');
  } else {
    next();
  }
});

export default router 